import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/common/insurable";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    insurable: [],
    initPage: [],

  },

  mutations: {
    setIsurable(state, data) {
      state.insurable = data;
    },
    setInitPage(state, data) {
      state.initPage = data;
    },
  },
  actions: {
    async getInsurable(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getInsurable();
          const pageInitInsurable = item.filter(element => {
            return element.code && typeof element.code === "string" && element.code.startsWith("menu:")
          })
          state.commit('setInitPage', pageInitInsurable)
          state.commit("setIsurable", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
   

  },
});
